import styled from 'styled-components'
import { Button } from 'syf-component-library/ui/atoms'

export const FullWidthButton = styled(Button)`
  width: 100%; /* same width as text fields */
  margin: 0;
`
